import React from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Query, withApollo } from "react-apollo";

import { registerToken } from './util';
import { clientCredentials } 								from './graphql/queries';

import Home 												from './components/Home';
import Privacy 												from './components/Privacy';
import { Header } 											from "./components/chunk"
import { Login, Migrate, Checkin,
			UserList, UserDetail, UserEdit } 				from "./components/user"
import { ChannelList, ChannelDetail } 						from "./components/channel"
import { NoteDetail, NoteList, NoteAdd } 					from "./components/note"
import { PostEdit } 										from './components/post';
import { CommentDetail } 									from './components/comment';
import { MailList, MailDetail } 							from './components/mail';


class App extends React.Component {

	state = {
		dragEnterCount: 0,
		isHover: false,
		timeout: null
	}

	componentDidMount() {
		try {
			const payload = registerToken(this.props.client);
			if(payload === -1) {
                window.location = '/login';
            }
		} catch(e) {
			console.log(e);
		}

		this.handleDrop = this.handleDrop.bind(this);
		this.handleDragEnter = this.handleDragEnter.bind(this);
		this.handleDragLeave = this.handleDragLeave.bind(this);
	}

	handleDrop() {
		if(this.state.dragEnterCount > 0) this.setState({isHover: false})
	}

	handleDragEnter(e) {
		const dragEnterCount = this.state.dragEnterCount + 1;
		this.setState({ dragEnterCount })
		if(dragEnterCount === 1) this.setState({isHover: true})
	}

	handleDragLeave(e) {
		const dragEnterCount = this.state.dragEnterCount - 1;
		this.setState({ dragEnterCount })
		if(dragEnterCount === 0) this.setState({isHover: false});
	}

	render() {
		const location = this.props.location.pathname.split('/')[1];
		const openEnds = ['login', 'migrate', 'checkin'];

		return (
			<Query query={clientCredentials}>
				{({ data }) => {
			      	if(!data || !data.clientCredentials) return (<div className="container"><div className="centered login">Apollo Bug :( pls reload ...</div></div>);
					if(!localStorage.getItem('token') && openEnds.indexOf(location) === -1) return (<Redirect to="/login" />);
					if(data.clientCredentials.id && location === 'migrate') return (<Redirect to="/login" />);
					return (
						<div ref={(elem) => { this.domNode = elem; }} 
							className={this.state.isHover ? "app app-dragover" : "app"}
							onDrop={this.handleDrop}
							onDragLeave={this.handleDragLeave}
							onDragEnter={this.handleDragEnter}
							onDragOver={(e) => e.preventDefault()}>
							<Header />
							<Switch>
								<Route path="/migrate" component={Migrate} /> 
								<Route path="/login" component={Login} /> 
								<Route path="/checkin/:token?/:handle?" component={Checkin} /> 
								<Route path="/privacy" component={Privacy} /> 
								<Route exact path="/" component={Home} />
							</Switch>
							<Switch>
								<Route exact path="/channels" component={ChannelList} /> 
								<Route path="/users" component={UserList} /> 
								{/*<Route path="/bookmarks" component={TileList} /> */}
								<Route path="/notes" component={NoteList} />
								<Route path="/mails" component={MailList} />
								{/*<Route component={NotFound} />*/}
							</Switch>
							
							<Switch>
								<Route exact path="/notes/add" component={NoteAdd} /> 
								<Route exact path="/notes/:id" component={NoteDetail} />

								<Route path="/users/:id/edit" component={UserEdit} />
								<Route path="/users/:id" component={UserDetail} />
								<Route path="/channels/:id" component={ChannelDetail} /> 
								<Route path="/mails/:id" component={MailDetail} /> 
							</Switch>

							<Switch>
								<Route exaxt path="/channels/:id/post" component={PostEdit} /> 
								<Route path="/channels/:id/post/:id_2" component={CommentDetail} /> 
							</Switch>
						</div>
					)
			}}
			</Query>
		)
	}
}

export default withRouter(withApollo(App));


// WEBPACK FOOTER //
// ./src/App.js